/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    DeviceTypeCertificateRequest,
    DeviceTypeCertificateRequestFromJSON,
    DeviceTypeCertificateRequestToJSON,
    DeviceTypeCertificateResponse,
    DeviceTypeCertificateResponseFromJSON,
    DeviceTypeCertificateResponseToJSON,
    DeviceTypeCertificatesResponse,
    DeviceTypeCertificatesResponseFromJSON,
    DeviceTypeCertificatesResponseToJSON,
    DeviceTypeRelationEntitiesResponse,
    DeviceTypeRelationEntitiesResponseFromJSON,
    DeviceTypeRelationEntitiesResponseToJSON,
    DeviceTypeRequest,
    DeviceTypeRequestFromJSON,
    DeviceTypeRequestToJSON,
    DeviceTypeResponse,
    DeviceTypeResponseFromJSON,
    DeviceTypeResponseToJSON,
    DeviceTypeSettingsRequest,
    DeviceTypeSettingsRequestFromJSON,
    DeviceTypeSettingsRequestToJSON,
    DeviceTypeSettingsResponse,
    DeviceTypeSettingsResponseFromJSON,
    DeviceTypeSettingsResponseToJSON,
    DeviceTypesResponse,
    DeviceTypesResponseFromJSON,
    DeviceTypesResponseToJSON,
    FirmwareResponse,
    FirmwareResponseFromJSON,
    FirmwareResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
} from '../models';

export interface CreateDeviceTypeRequest {
    deviceTypeRequest: DeviceTypeRequest;
}

export interface CreateDeviceTypeCertificateRequest {
    deviceTypeId: string;
    deviceTypeCertificateRequest: DeviceTypeCertificateRequest;
}

export interface DeleteDeviceTypeRequest {
    id: string;
}

export interface DeleteDeviceTypeCertificateRequest {
    deviceTypeId: string;
    deviceTypeCertificateId: string;
}

export interface ReadDeviceTypeRequest {
    id: string;
}

export interface ReadDeviceTypeCertificateRequest {
    deviceTypeId: string;
    deviceTypeCertificateId: string;
}

export interface ReadDeviceTypeCertificatesRequest {
    deviceTypeId: string;
    offset?: number | null;
    limit?: number | null;
}

export interface ReadDeviceTypeFirmwaresRequest {
    id: string;
}

export interface ReadDeviceTypeRelationEntitiesRequest {
    id: string;
}

export interface ReadDeviceTypeSettingsRequest {
    id: string;
}

export interface UpdateDeviceTypeRequest {
    id: string;
    deviceTypeRequest: DeviceTypeRequest;
}

export interface UpdateDeviceTypeCertificateRequest {
    deviceTypeId: string;
    deviceTypeCertificateId: string;
    deviceTypeCertificateRequest: DeviceTypeCertificateRequest;
}

export interface UpdateDeviceTypeSettingsRequest {
    id: string;
    deviceTypeSettingsRequest: DeviceTypeSettingsRequest;
}

/**
 * 
 */
export class DeviceTypesApi extends runtime.BaseAPI {

    /**
     * Create a new device type.
     */
    async createDeviceTypeRaw(requestParameters: CreateDeviceTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.deviceTypeRequest === null || requestParameters.deviceTypeRequest === undefined) {
            throw new runtime.RequiredError('deviceTypeRequest','Required parameter requestParameters.deviceTypeRequest was null or undefined when calling createDeviceType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTypeRequestToJSON(requestParameters.deviceTypeRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new device type.
     */
    async createDeviceType(requestParameters: CreateDeviceTypeRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createDeviceTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new device type certificate.
     */
    async createDeviceTypeCertificateRaw(requestParameters: CreateDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling createDeviceTypeCertificate.');
        }

        if (requestParameters.deviceTypeCertificateRequest === null || requestParameters.deviceTypeCertificateRequest === undefined) {
            throw new runtime.RequiredError('deviceTypeCertificateRequest','Required parameter requestParameters.deviceTypeCertificateRequest was null or undefined when calling createDeviceTypeCertificate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{deviceTypeId}/certificates`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTypeCertificateRequestToJSON(requestParameters.deviceTypeCertificateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new device type certificate.
     */
    async createDeviceTypeCertificate(requestParameters: CreateDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createDeviceTypeCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete device type by ID.
     */
    async deleteDeviceTypeRaw(requestParameters: DeleteDeviceTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDeviceType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete device type by ID.
     */
    async deleteDeviceType(requestParameters: DeleteDeviceTypeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteDeviceTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Delete device type certificate by ID.
     */
    async deleteDeviceTypeCertificateRaw(requestParameters: DeleteDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling deleteDeviceTypeCertificate.');
        }

        if (requestParameters.deviceTypeCertificateId === null || requestParameters.deviceTypeCertificateId === undefined) {
            throw new runtime.RequiredError('deviceTypeCertificateId','Required parameter requestParameters.deviceTypeCertificateId was null or undefined when calling deleteDeviceTypeCertificate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{deviceTypeId}/certificates/{deviceTypeCertificateId}`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))).replace(`{${"deviceTypeCertificateId"}}`, encodeURIComponent(String(requestParameters.deviceTypeCertificateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete device type certificate by ID.
     */
    async deleteDeviceTypeCertificate(requestParameters: DeleteDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteDeviceTypeCertificateRaw(requestParameters, initOverrides);
    }

    /**
     * Read device type by ID.
     */
    async readDeviceTypeRaw(requestParameters: ReadDeviceTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypeResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readDeviceType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypeResponseFromJSON(jsonValue));
    }

    /**
     * Read device type by ID.
     */
    async readDeviceType(requestParameters: ReadDeviceTypeRequest, initOverrides?: RequestInit): Promise<DeviceTypeResponse> {
        const response = await this.readDeviceTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device type certificate.
     */
    async readDeviceTypeCertificateRaw(requestParameters: ReadDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypeCertificateResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readDeviceTypeCertificate.');
        }

        if (requestParameters.deviceTypeCertificateId === null || requestParameters.deviceTypeCertificateId === undefined) {
            throw new runtime.RequiredError('deviceTypeCertificateId','Required parameter requestParameters.deviceTypeCertificateId was null or undefined when calling readDeviceTypeCertificate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{deviceTypeId}/certificates/{deviceTypeCertificateId}`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))).replace(`{${"deviceTypeCertificateId"}}`, encodeURIComponent(String(requestParameters.deviceTypeCertificateId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypeCertificateResponseFromJSON(jsonValue));
    }

    /**
     * Read device type certificate.
     */
    async readDeviceTypeCertificate(requestParameters: ReadDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<DeviceTypeCertificateResponse> {
        const response = await this.readDeviceTypeCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device type certificates by device type ID.
     */
    async readDeviceTypeCertificatesRaw(requestParameters: ReadDeviceTypeCertificatesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypeCertificatesResponse>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling readDeviceTypeCertificates.');
        }

        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{deviceTypeId}/certificates`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypeCertificatesResponseFromJSON(jsonValue));
    }

    /**
     * Read device type certificates by device type ID.
     */
    async readDeviceTypeCertificates(requestParameters: ReadDeviceTypeCertificatesRequest, initOverrides?: RequestInit): Promise<DeviceTypeCertificatesResponse> {
        const response = await this.readDeviceTypeCertificatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device type firmwares by ID.
     */
    async readDeviceTypeFirmwaresRaw(requestParameters: ReadDeviceTypeFirmwaresRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: Array<FirmwareResponse>; }>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readDeviceTypeFirmwares.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}/firmwares`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read device type firmwares by ID.
     */
    async readDeviceTypeFirmwares(requestParameters: ReadDeviceTypeFirmwaresRequest, initOverrides?: RequestInit): Promise<{ [key: string]: Array<FirmwareResponse>; }> {
        const response = await this.readDeviceTypeFirmwaresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read all entities related to device type.
     */
    async readDeviceTypeRelationEntitiesRaw(requestParameters: ReadDeviceTypeRelationEntitiesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypeRelationEntitiesResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readDeviceTypeRelationEntities.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}/relationEntities`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypeRelationEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * Read all entities related to device type.
     */
    async readDeviceTypeRelationEntities(requestParameters: ReadDeviceTypeRelationEntitiesRequest, initOverrides?: RequestInit): Promise<DeviceTypeRelationEntitiesResponse> {
        const response = await this.readDeviceTypeRelationEntitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device type settings by ID.
     */
    async readDeviceTypeSettingsRaw(requestParameters: ReadDeviceTypeSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypeSettingsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readDeviceTypeSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}/settings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypeSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Read device type settings by ID.
     */
    async readDeviceTypeSettings(requestParameters: ReadDeviceTypeSettingsRequest, initOverrides?: RequestInit): Promise<DeviceTypeSettingsResponse> {
        const response = await this.readDeviceTypeSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read device types.
     */
    async readDeviceTypesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypesResponseFromJSON(jsonValue));
    }

    /**
     * Read device types.
     */
    async readDeviceTypes(initOverrides?: RequestInit): Promise<DeviceTypesResponse> {
        const response = await this.readDeviceTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read device types that don\'t have rescue firmware.
     */
    async readRescueDeviceTypesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeviceTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/notRescue`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeviceTypesResponseFromJSON(jsonValue));
    }

    /**
     * Read device types that don\'t have rescue firmware.
     */
    async readRescueDeviceTypes(initOverrides?: RequestInit): Promise<DeviceTypesResponse> {
        const response = await this.readRescueDeviceTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update device type by ID.
     */
    async updateDeviceTypeRaw(requestParameters: UpdateDeviceTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDeviceType.');
        }

        if (requestParameters.deviceTypeRequest === null || requestParameters.deviceTypeRequest === undefined) {
            throw new runtime.RequiredError('deviceTypeRequest','Required parameter requestParameters.deviceTypeRequest was null or undefined when calling updateDeviceType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTypeRequestToJSON(requestParameters.deviceTypeRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update device type by ID.
     */
    async updateDeviceType(requestParameters: UpdateDeviceTypeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateDeviceTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Update device type certificate.
     */
    async updateDeviceTypeCertificateRaw(requestParameters: UpdateDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.deviceTypeId === null || requestParameters.deviceTypeId === undefined) {
            throw new runtime.RequiredError('deviceTypeId','Required parameter requestParameters.deviceTypeId was null or undefined when calling updateDeviceTypeCertificate.');
        }

        if (requestParameters.deviceTypeCertificateId === null || requestParameters.deviceTypeCertificateId === undefined) {
            throw new runtime.RequiredError('deviceTypeCertificateId','Required parameter requestParameters.deviceTypeCertificateId was null or undefined when calling updateDeviceTypeCertificate.');
        }

        if (requestParameters.deviceTypeCertificateRequest === null || requestParameters.deviceTypeCertificateRequest === undefined) {
            throw new runtime.RequiredError('deviceTypeCertificateRequest','Required parameter requestParameters.deviceTypeCertificateRequest was null or undefined when calling updateDeviceTypeCertificate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{deviceTypeId}/certificates/{deviceTypeCertificateId}`.replace(`{${"deviceTypeId"}}`, encodeURIComponent(String(requestParameters.deviceTypeId))).replace(`{${"deviceTypeCertificateId"}}`, encodeURIComponent(String(requestParameters.deviceTypeCertificateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTypeCertificateRequestToJSON(requestParameters.deviceTypeCertificateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update device type certificate.
     */
    async updateDeviceTypeCertificate(requestParameters: UpdateDeviceTypeCertificateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateDeviceTypeCertificateRaw(requestParameters, initOverrides);
    }

    /**
     * Update device type settings by ID.
     */
    async updateDeviceTypeSettingsRaw(requestParameters: UpdateDeviceTypeSettingsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDeviceTypeSettings.');
        }

        if (requestParameters.deviceTypeSettingsRequest === null || requestParameters.deviceTypeSettingsRequest === undefined) {
            throw new runtime.RequiredError('deviceTypeSettingsRequest','Required parameter requestParameters.deviceTypeSettingsRequest was null or undefined when calling updateDeviceTypeSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deviceTypes/{id}/settings`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceTypeSettingsRequestToJSON(requestParameters.deviceTypeSettingsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update device type settings by ID.
     */
    async updateDeviceTypeSettings(requestParameters: UpdateDeviceTypeSettingsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateDeviceTypeSettingsRaw(requestParameters, initOverrides);
    }

}
